import { Node } from "neovis.js";

export function addAccountNode(node: Node, consulta: string) {
  if (
    JSON.stringify(node).toLowerCase().includes(consulta) &&
    hasPermission('view_accounts')
  ) {
    return ({
      id: node.id,
      titulo: node.label,
      description: 'Cuenta',
      type: 'Cuenta',
      color: 'red',
      icon: 'account_balance',
      node_object: node,
      checked: true
    });
  }
}

export function addCustomerNode(node: Node, consulta: string) {
  if (
    JSON.stringify(node).toLowerCase().includes(consulta) &&
    hasPermission('view_customers')
  ) {
    return ({
      id: node.id,
      titulo: node.label,
      description: 'CI: ' + node.value,
      type: 'Cliente',
      color: 'blue',
      icon: 'person',
      node_object: node,
      checked: true
    });
  }
}

export function addCasoNode(node: Node, consulta: string) {
  if (
    JSON.stringify(node).toLowerCase().includes(consulta) &&
    hasPermission('view_cases')
  ) {
    return {
      id: node.id,
      titulo: node.label,
      description: 'Caso',
      type: 'Caso',
      color: 'green',
      icon: 'case',
      node_object: node,
      checked: true
    };
  }
}

export function addDefaultNode(node: Node, consulta: string) {
  if (
    JSON.stringify(node).toLowerCase().includes(consulta) &&
    hasPermission('view_cases')
  ) {
    return {
      id: node.id,
      titulo: node.label,
      description: '',
      type: node.raw.labels[0],
      color: 'green',
      icon: 'person',
      node_object: node,
      checked: true
    };
  }
}

function hasPermission(permission: string): boolean {
  // Check if the user has the specified permission
  // Return true if the user has the permission, false otherwise
  // You can implement this method based on your authentication and authorization logic
  return true;
}